export class GetExitPointPredictionAction {
  static readonly type = '[exitPointPrediction] Get Exit Point Predictions';
  constructor(public payload: any) {}
}

export class SetMarketsFilter {
  static readonly type = '[exitPointPrediction] Set Markets Filter';
  constructor(public payload: any[]) {}
}

export class SetGatesFilter {
  static readonly type = '[exitPointPrediction] Set Gates Filter';
  constructor(public payload: any[]) {}
}

export class SetCreg185 {
  static readonly type = '[exitPointPrediction] Set Creg185';
  constructor(public payload: boolean) {}
}
